import styled from 'styled-components';

export const Wrapper = styled.div.attrs<{ className?: string }>({
  className:
    'flex w-full md:w-auto min-w-0 items-center gap-1.5 overflow-x-auto pb-3 md:flex-wrap md:overflow-visible md:py-3 [&>*]:shrink-0',
})`
  .name {
    color: var(--color-text-muted);
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%; /* 14.4px */
  }
`;
